import { PlanningCycleRow } from './planningCycle.models';

export const normalizePlanningCycleRow = (r: any): PlanningCycleRow => ({
  rid: Number(r.rid ?? r.recid ?? r.id),
  code: r.code ?? r.shortcode ?? r.shc ?? '',
  name: r.name ?? r.recname ?? r.nam ?? '',
  description: r.description ?? r.dsc ?? '',
  budgetperiodid: Number(r.budgetperiodid ?? r.bpi ?? 0),
  budgetperiodcode: r.budgetperiodcode ?? r.bpc ?? '',
  budgetperiodname: r.budgetperiodname ?? r.bpn ?? '',
  periodstartdate: r.periodstartdate ?? null,
  periodenddate: r.periodenddate ?? null,
  fiscalyear: r.fiscalyear ?? '',
  stateid: Number(r.stateid ?? r.sti ?? 0),
  statecode: r.statecode ?? r.stc ?? '',
  statename: r.statename ?? r.stn ?? '',
  phaseid: Number(r.phaseid ?? r.phi ?? 0),
  phasecode: r.phasecode ?? r.phc ?? '',
  phasename: r.phasename ?? r.phn ?? '',
  creatorid: r.creatorid ?? null,
  closerid: r.closerid ?? null,
  closedat: r.closedat ?? null,
  extrainfo: r.extrainfo ?? {},
  status: Number(r.status ?? r.ast ?? 1),
  created: r.created,
  stamp: r.stamp,
});
